import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { WarehousesState } from './warehouses.reducers';

export const selectWarehousesState = (state: AppState) => state.warehouses;

// Warehouses selectors
export const selectWarehouses = createSelector(
  selectWarehousesState,
  (state: WarehousesState) => state.warehouses
);

export const selectMetadata = createSelector(
  selectWarehousesState,
  (state: WarehousesState) => state.metadata
);
export const selectIsLoading = createSelector(
  selectWarehousesState,
  (state: WarehousesState) => state.loading
);
export const selectIsSaving = createSelector(
  selectWarehousesState,
  (state: WarehousesState) => state.saving
);